import { render, staticRenderFns } from "./FullScreenLoading.vue?vue&type=template&id=70b0c136&scoped=true&"
var script = {}
import style0 from "./FullScreenLoading.vue?vue&type=style&index=0&id=70b0c136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0c136",
  null
  
)

export default component.exports